// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"441":"7dc92913","1777":"9f47d5ec"}[chunkId] + ".chunk.css";
};